import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <MediaSection />
        <FeaturesSection />
        <CardsSection />
        <IndexSection />
        <RankingSection />
        <UpdatesSection />
        <CarouselSection />
        <TopicsSection />
        <AppSection />
        <CommentsSection />
        <ContactSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}